module.exports = __webpack_public_path__ + "img/autospin_btn.02e62300.png";